import type { LeadDto } from '@/shared/types/domain';
import { Pill } from '@/shared/components/Pill';
import './LeadListItem.css';

const RATING_TONE = { Hot: 'hot', Warm: 'warm', Cold: 'cold' } as const;

export function LeadListItem({ lead, onClick }: { lead: LeadDto; onClick: () => void }) {
  const scannedAt = new Date(lead.scannedAtUtc);

  return (
    <button type="button" className="lead-item" onClick={onClick}>
      <div className="lead-item__main">
        <span className="lead-item__name">
          {lead.consentGiven ? `${lead.firstName} ${lead.lastName}` : 'Consent not given'}
        </span>
        <span className="lead-item__meta">
          {lead.consentGiven ? lead.company : lead.consentMessage}
        </span>
        <span className="lead-item__badge font-mono">{lead.badgeId}</span>
      </div>

      <div className="lead-item__side">
        {lead.rating && <Pill tone={RATING_TONE[lead.rating]}>{lead.rating}</Pill>}
        <time className="lead-item__time" dateTime={lead.scannedAtUtc}>
          {scannedAt.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
        </time>
      </div>
    </button>
  );
}
